// extracted by mini-css-extract-plugin
module.exports = {"expandedFrontSection":"front-products_expandedFrontSection__QQVra","productDetailsWrapper":"front-products_productDetailsWrapper__Fsmki"};